// Pacific Siren · testIds registry

export const HOME = { emergentLink: "home-emergent-link" };

export const NAV = {
  brand: "nav-brand",
  applyCta: "nav-apply-cta",
  linkContest: "nav-link-contest",
  linkStorefront: "nav-link-storefront",
  linkStream: "nav-link-stream",
  linkCollege: "nav-link-college",
  linkSocial: "nav-link-social",
  linkLeaderboard: "nav-link-leaderboard",
  linkAdmiral: "nav-link-admiral",
  linkArmada: "nav-link-armada",
};

export const LANDING = {
  applyHeroBtn: "apply-admiral-commission-btn",
  applyStickyBtn: "apply-admiral-commission-sticky-btn",
  countdownDays: "countdown-days",
  countdownHours: "countdown-hours",
  countdownMinutes: "countdown-minutes",
  countdownSeconds: "countdown-seconds",
  prizeCard: "prize-card",
  raffleSection: "raffle-section",
  viralStrikePrize: "viral-strike-prize",
  armadaSection: "armada-section",
  armadaSectorCard: "armada-sector-card",
  armadaRequestBtn: "armada-request-custom-hull-btn",
};

export const BOARDING = {
  modal: "boarding-modal",
  stepIndicator: "boarding-step-indicator",
  fieldFullName: "boarding-full-name",
  fieldEmail: "boarding-email",
  fieldPhone: "boarding-phone",
  fieldTiktok: "boarding-tiktok",
  fieldInstagram: "boarding-instagram",
  fieldYoutube: "boarding-youtube",
  fieldFollowerCount: "boarding-follower-count",
  fieldEngagementRate: "boarding-engagement-rate",
  fieldVideoLink: "boarding-video-link",
  fieldNiche: "boarding-niche",
  fieldNarrative: "boarding-narrative",
  fieldPortfolioUpload: "boarding-portfolio-upload",
  nextBtn: "boarding-next-btn",
  backBtn: "boarding-back-btn",
  submitBtn: "boarding-submit-stripe-btn",
  closeBtn: "boarding-close-btn",
};

export const LEADERBOARD = {
  card: "leaderboard-card",
  upvoteBtn: "upvote-btn",
  upvoteCount: "upvote-count",
  voteModal: "vote-modal",
  voteEmail: "vote-email",
  voteName: "vote-name",
  voteRequestBtn: "vote-request-btn",
  voteCode: "vote-code",
  voteVerifyBtn: "vote-verify-btn",
};

export const PORTAL = {
  ticket: "candidate-ticket",
  ticketNumber: "candidate-ticket-number",
  shareLink: "candidate-share-link",
};

export const ADMIN = {
  loginEmail: "admin-login-email",
  loginPassword: "admin-login-password",
  loginBtn: "admin-login-btn",
  statsCard: "admin-stats-card",
  rosterRow: "admin-roster-row",
  logoutBtn: "admin-logout-btn",
};

export const ARMADA = {
  pageHero: "armada-page-hero",
  sectorCard: "armada-sector-card",
  requestModal: "armada-request-modal",
  requestEmail: "armada-request-email",
  requestName: "armada-request-name",
  requestSector: "armada-request-sector",
  requestNotes: "armada-request-notes",
  requestSubmitBtn: "armada-request-submit-btn",
};
